import { Injectable } from '@angular/core';
import {
  isValidFiniteNumber,
  TimeSeriesDataPointStatus,
} from '@anessa/shared-models';
import { TimeSeriesTableColumn } from '../models/timeseries-table.model';

@Injectable({ providedIn: 'root' })
export class TimeSeriesValidationService {
  hasAllRequiredValues(
    columns: TimeSeriesTableColumn[],
    values: Record<string, string>,
  ): boolean {
    return columns.every(
      (column) =>
        !column.required || (values[column.key] ?? '').trim().length > 0,
    );
  }

  hasInvalidNumberValue(
    column: TimeSeriesTableColumn,
    values: Record<string, string>,
  ): boolean {
    if (column.dataType !== 'number') return false;

    const value = (values[column.key] ?? '').trim();
    if (!value) return false;

    return !isValidFiniteNumber(value);
  }

  hasInvalidNumberValues(
    columns: TimeSeriesTableColumn[],
    values: Record<string, string>,
  ): boolean {
    return columns.some((column) => this.hasInvalidNumberValue(column, values));
  }

  inferStatusFromValues(
    columns: TimeSeriesTableColumn[],
    values: Record<string, string>,
  ): TimeSeriesDataPointStatus {
    return this.hasAllRequiredValues(columns, values) ? 'submitted' : 'draft';
  }
}
